import { FunctionComponent } from 'react';
import { useRouter } from 'next/router';

import { Routes } from 'types/routes';

import { imageResizer } from 'utils/image';
import { shorten, withVariables } from 'utils/string';

import { Props } from './index';
import StyledComponent from './styles';

const PublicLayoutJobsSmallJobBoxMobile: FunctionComponent<Props> = ({ job, iconsAlts }) => {
    const router = useRouter();

    return (
        <StyledComponent className="public-layout-jobs-small-job-box-mobile">
            <a
                className='offer-link'
                    href={ job?.cbopUrl? job.cbopUrl : withVariables(Routes?.PublicJob, { slug: job?.slug }, { jobCitySlug: job?.primaryCity?.id })} 
                    target={job?.cbopUrl ? "_blank" : undefined}
            >
                <div className="image-container">
                    <img
                        className="offer-image"
                        src={job.createSource === 'cbop' ? '/images/jobs/e-praca-logo.svg' : (imageResizer(job.companyLogo?.imageUrl, { width: 200 }) || '/images/jobs/image-placeholder.svg')}
                        loading="lazy"
                        alt={job?.companyName}
                        width='112'
                        height='112'
                    />
                </div>
                <div className="offer-content">
                    <div
                        className="offer-name"
                        dangerouslySetInnerHTML={{ __html: shorten(job?.name, 30, true) }}
                    />
                    <div
                        className="company-name"
                        dangerouslySetInnerHTML={{ __html: job?.companyName }}
                    />
                    {job?.companyFullAddress && (
                        <div className="content-description">
                            <div className="location">
                                <img
                                    className="icon"
                                    src="/images/icons/bullet3.svg"
                                    loading="lazy"
                                    width="20"
                                    height="auto"
                                    alt={iconsAlts?.location}
                                />
                                <div
                                    className="title"
                                    dangerouslySetInnerHTML={{ __html: job?.primaryCity?.companyFullAddress }}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </a>
        </StyledComponent>
    );
};

export default PublicLayoutJobsSmallJobBoxMobile;